var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-russian-post"},[_vm._v("Доставка Почтой России.")])
}
var staticRenderFns = []

export { render, staticRenderFns }